import type { GetTwoFACodeResponse } from '@/api';
import { TwoFACodeData } from '../models';

const getTwoFaCode = (response: GetTwoFACodeResponse): TwoFACodeData => {
  const { data } = response;
  return data;
};

export { getTwoFaCode };
